export const MoneyPlusMinus = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="3" y="3" width="26" height="14" rx="1" stroke="currentColor" stroke-width="2"/>
<circle cx="16" cy="10" r="3" stroke="currentColor" stroke-width="2"/>
<circle cx="24" cy="10" r="1" stroke="currentColor" stroke-width="2"/>
<circle cx="8" cy="10" r="1" stroke="currentColor" stroke-width="2"/>
<rect x="4.5" y="24.5" width="9" height="1" stroke="currentColor"/>
<rect x="9.5" y="20.5" width="9" height="1" transform="rotate(90 9.5 20.5)" stroke="currentColor"/>
<rect x="18.5" y="24.5" width="9" height="1" stroke="currentColor"/>
</svg>`;
